export const CREATE_CARD = 'CREATE_CARD';
export const CREATE_CARD_SUCCESS = 'CREATE_CARD_SUCCESS';
export const CREATE_CARD_FAILURE = 'CREATE_CARD_FAILURE';



// WEBPACK FOOTER //
// ./src/routes/CreateRoar/StepFour/modules/constants.js